<template>
    <div class="template-icon">
        <img
            v-if="icon"
            :src="icon"
            alt="Icoon"
        />
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import LogoRealworks from '@/assets/icons/realworks.png';
    import LogoWinck from '@/assets/icons/winck.png';

    const props = defineProps<{ icon?: string }>();
    const icon = computed(() => {
        switch (props.icon) {
            case 'realworks': return LogoRealworks;
            case 'winck': return LogoWinck;
            default: return props.icon ?? false;
        }
    });
</script>

<style lang="scss">
.template-icon {
    justify-content: center;

    img {
        object-fit: contain;
        max-width: 26px;
        max-height: 26px;
        padding: 16px;
        border-radius: 100%;
        background-color: color(gray-200);
    }
}
</style>
